<template>
  <div class="banners"
       :style="{ 'background': 'url(' + banner + ') no-repeat center', 'background-size': 'cover'}">
  </div>
</template>

<script>
  export default {
    name: 'Banners',
    props: ['banner'],
    data() {
      return {
      }
    },
  }
</script>

<style scoped lang="scss" type="text/scss">
  .banners {
    width: 100%;
    height: 3rem;
  }

</style>



// WEBPACK FOOTER //
// src/mComponents/Banners.vue